<template>
  <el-row v-loading="isLoading">
    <el-col :span="16" class="cs-academicInfo-panel-left">
      <el-row>
        <el-col>
          <span class="cs-title cs-bold">学术信息</span>
        </el-col>
      </el-row>
      <el-row class="cs-academicInfo-row cs-academicInfo-link-container">
        <el-col :span="16" class="cs-academicInfo-link">
          <el-link type="primary" :underline="false" @click="onStudentListClick">真留学生列表</el-link>
          <i class="el-icon-arrow-right"></i>
          <span>学术信息</span>
        </el-col>
        <el-col :span="8" class="text-right">
          <el-select @change="onTermChange" placeholder="学期" v-model="selectedTermId" size="medium">
            <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="cs-academicInfo-row">
        <el-col>
          <scoreList :scoreType="1" :dataIn="scoreListData" :isReadonly="isReadonly" />
        </el-col>
      </el-row>
      <el-row class="cs-academicInfo-row">
        <el-col>
          <scoreList :scoreType="2" :dataIn="scoreListData" :isReadonly="isReadonly" />
        </el-col>
      </el-row>
      <el-row class="cs-academicInfo-row">
        <el-col>
          <tuitionInfo :dataIn="scoreListData" :isReadonly="isReadonly" />
        </el-col>
      </el-row>
    </el-col>
    <el-col :span="8" class="cs-academicInfo-panel-right">
      <el-row class="content-block">
        <el-col>
          <studentInfo :studentInfoData="studentInfoData" :isReadonly="isReadonly"/>
        </el-col>
      </el-row>
      <el-row class="content-block">
        <el-col>
          <studiesRelatedInfo :studentId="dataIn.studentId" :isReadonly="isReadonly" />
        </el-col>
      </el-row>
      <el-row class="content-block">
        <el-col>
          <academicAnalysisReport :studentId="dataIn.studentId" :isReadonly="isReadonly" />
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.cs-academicInfo-panel-left{
  padding-right: 40px;
  border-right: 1px solid #ced3d9;
  .cs-academicInfo-row{
    border-bottom: 1px solid #ced3d9;
    padding: 1rem 0;
  }
  .cs-academicInfo-link-container{
    padding-top: 0;
    padding-bottom: 10px;
  }
  .cs-academicInfo-link{
    i{
      vertical-align:middle;
    }
    .el-link{
      &:hover{
        text-decoration:none;
      }
    }
  }
}
.cs-academicInfo-panel-right{
  padding-left: 40px;
  
  .content-block {
    margin-bottom: 40px;
  }
}
</style>

<script>
import { getTerms } from "../../../service/common.service";
import {
  getStudentMemberInfo
} from "../../../service/student.service";

export default {
  name: "academicInfo",
  components: {
    studentInfo: () => import("./studentInfo"),
    scoreList: () => import("./scoreList"),
    tuitionInfo: () => import("./tuitionInfo"),
    studiesRelatedInfo: () => import("./studiesRelatedInfo"),
    academicAnalysisReport: () => import("./academicAnalysisReport")
  },
  props: {
    dataIn: {
      studentId: Number
    }
  },
  data() {
    return {
      isReadonly: this.USERMANAGER.isSAFinancialAssistant,
      selectedTermId: "",
      termList: null,
      studentInfoData:{},
      isLoading: false,
      scoreListData:{
        termId: 0,
        termName: "",
        studentId: 0
      },
    };
  },
  created() {
    this.isLoading = true;
    getTerms(false, true, false, this.dataIn.studentId).then((result) => {
      if (!!result && result.success) {
        this.termList = result.data;

        if (this.termList.length > 0) {
          let currentTerm = result.data.find((i) => i.IsCurrentTerm);
          if (!!currentTerm) {
            this.selectedTermId = currentTerm.Id;
          } else {
            this.selectedTermId = this.termList[0].Id;
          }
        }
        this.checkLoading();
      }
    });
    this.init();
  },
  methods: {
    init(){
      if (!this.dataIn || !this.dataIn.studentId){
        return;
      }
      this.isLoading = true;
      getStudentMemberInfo(this.dataIn.studentId, "").then(result => {
        if (result && result.success) {
          this.studentInfoData = result.data;
          this.checkLoading();
        }
      });
    },
    checkLoading(){
      if (this.studentInfoData && Object.keys(this.studentInfoData).length > 0
        && this.termList && this.termList.length > 0) {
        this.isLoading = false;
        this.getScoreListData();
      }
    },
    onStudentListClick() {
      this.$emit("close");
    },
    onTermChange(){
      this.getScoreListData();
    },
    getScoreListData(){
      let term = this.termList.find(i => i.Id == this.selectedTermId);
      let termName = "";
      if (term){
        termName = term.DisplayLable;
      }
      this.scoreListData = {
        termId: this.selectedTermId,
        termName: termName,
        studentId: this.dataIn.studentId
      }
    }
  },
  watch:{
    dataIn: function(){
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/main.vue